import type { PartsProduct } from '@app/react/const/type';

/**
 * 矢尺が選択済みであるか
 * @module isSelectedAdjustProduct
 * @param {boolean} adjust
 * @param {PartsProduct | null} product
 * @return {'none' | 'valid'} - 調整なしは選択済み。調整ありであるならば、商品が選択されているか
 */
export const isSelectedAdjustProduct = (
    adjust: boolean | null,
    product: PartsProduct | null,
): 'none' | 'valid' => {
    const cond1 = adjust === true && product === null && 'none';
    const cond2 = adjust === true && product !== null && 'valid';
    const cond3 = adjust === false && product === null && 'valid';

    return cond1 || cond2 || cond3 || 'none';
};
